import { AgentCompaniesList as AgentCompaniesListComponent } from './AgentCompaniesList.component';
import { connector } from './AgentCompaniesList.connector';

export const AgentCompaniesList = connector(AgentCompaniesListComponent);
